// extracted by mini-css-extract-plugin
export var pillWrapper = "_xy-0";
export var showOverflow = "_xy-1";